var PaeService = function ($q, paeFactory, accountService) {

  var service = this;
  //This calls the factory to get PAE user status.
  service.checkPaeUser = function() {
      var deferred = $q.defer();

      paeFactory.getCheckPaeUser
        .query(accountService.getActiveGroupAccount(), function (data) {
          deferred.resolve(data);
      }, function (response) {
          deferred.reject();
      });

      return deferred.promise;
  }
};

PaeService.$inject = ['$q', 'paeFactory', 'accountService'];
export default PaeService;
